(function (window, undefined) {
    'use strict';

    var timeline,
        map,
        manager,
        header,
        prop = {};

    prop.env = 'production';
    // NOTE: timeline filter機能追加のため一時的にdevelopmentを指定
    // prop.env = 'development';
    // prop.env = 'preview';
    // if (window.location.host === 'internal.aurora4d.jp') {
    //     prop.env = 'internal';
    // }

    timeline = window.timelinemap.fn.timeline(prop);
    map = window.timelinemap.fn.map(prop);
    manager = window.timelinemap.fn.manager(prop);
    header = window.timelinemap.fn.header();

    window.timelinemap.timeline = timeline;
    window.timelinemap.map = map;
    window.timelinemap.manager = manager;
    window.timelinemap.header = header;

    window.timelinemap.header.init();
    if ($('#timeline').length) {
        window.timelinemap.timeline.init();
        window.timelinemap.map.init();
        window.timelinemap.manager.init();
    }

    $('#js-scrolltop').click(function () {
        var duration = 240,
            begin = (new Date() - 0),
            offset = window.pageYOffset,
            timer = setInterval(function() {
                var current = new Date() - begin;

                if (current > duration) {
                    clearInterval(timer);
                    current = duration;
                }
                window.scrollTo(0, offset * (1 - (current / duration)))
            }, 10);
    });
}(this));
